import { fromJS } from 'immutable';

export const REDUX_ACTION_PREFIX = 'modules/axp-travel-search-hotels';
export const SET_REQUEST = `${REDUX_ACTION_PREFIX}/SET_REQUEST`;
export const SET_ROOMS_TRAVELERS = `${REDUX_ACTION_PREFIX}/SET_ROOMS_TRAVELERS`;
export const SET_LOCATION = `${REDUX_ACTION_PREFIX}/SET_LOCATION`;
export const SET_DATES = `${REDUX_ACTION_PREFIX}/SET_DATES`;
export const SET_INAV_LOCATION = `${REDUX_ACTION_PREFIX}/SET_INAV_LOCATION`;
export const RESET_REQUEST = `${REDUX_ACTION_PREFIX}/RESET_REQUEST`;

export const setRequestAction = (request) => ({
  type: SET_REQUEST,
  request,
});

export const setRooms = (rooms) => ({
  type: SET_ROOMS_TRAVELERS,
  rooms,
});

export const setLocation = (location) => ({
  type: SET_LOCATION,
  location,
});

export const setDates = (dates) => ({
  type: SET_DATES,
  dates,
});

export const setInavLocation = (inavLocation) => ({
  type: SET_INAV_LOCATION,
  inavLocation,
});

export const DEFAULT_HOTEL = {
  rooms: [{
    adults: 2,
    children: [],
  }],
  location: {},
  startDate: null,
  endDate: null,
};

export const initialState = fromJS(DEFAULT_HOTEL);

// eslint-disable-next-line default-param-last -- required
const requestReducer = (state = initialState, action) => {
  switch (action && action.type) {
    case SET_REQUEST: {
      return fromJS({ ...state.toJS(), ...action.request });
    }
    case SET_ROOMS_TRAVELERS: {
      return state.set('rooms', fromJS(action.rooms));
    }
    case SET_LOCATION: {
      return state.set('location', fromJS(action.location));
    }
    case SET_DATES: {
      const { startDate, endDate } = action.dates;
      return state.set('startDate', fromJS(startDate)).set('endDate', fromJS(endDate));
    }
    case SET_INAV_LOCATION: {
      const { inavLocation } = action;
      return state.set('inavLocation', inavLocation);
    }
    case RESET_REQUEST: {
      return fromJS(DEFAULT_HOTEL);
    }
    default:
      return state;
  }
};

export default requestReducer;
